const colors = {
  ferrariRed: {
    50: "#C05340",
    300: "#CC4A33",
    600: "#D94126",
    900: "#FF2600",
  },
};

export default colors;
